import { createOptionsFrom } from "@/lib/common/Option";

export const PrepopulateSetLabels = {
	Wtr1stEdition: "Welcome to Rathe 1st Edition",
	WtrUnlimitedEdition: "Welcome to Rathe Unlimited",
	Arc1stEdition: "Arcane Rising 1st Edition",
	ArcUnlimitedEdition: "Arcane Rising Unlimited",
	Cru1stEdition: "Crucible of War 1st Edition",
	CruUnlimitedEdition: "Crucible of War Unlimited",
	Mon1stEdition: "Monarch 1st Edition",
	MonUnlimitedEdition: "Monarch Unlimited",
	Ele1stEdition: "Tales of Aria 1st Edition",
	EleUnlimitedEdition: "Tales of Aria Unlimited",
	Evr1stEdition: "Everfest 1st Edition",
	Upr: "Uprising",
	Dyn: "Dynasty",
	Out: "Outsiders",
	Dtd: "Dusk till Dawn",
	Evo: "Bright Lights",
	Hvy: "Heavy Hitters",
	Mst: "Part the Mistveil",
	Ros: "Rosetta",
	Hnt: "The Hunted",
	Sea: "High Seas",
	Mpg: "Mastery Pack Guardian",
	Sup: "Super Slam",
	Pen: "Compendium of Rathe",
	Anq: "Antiquity Pack",
	Omn: "Omens of the Third Age",
	Mpw: "Mastery Pack Warrior",
	Iar: "Usurp the Shadow Throne",
	Lgs: "Local Game Store Promos",
	Her: "Hero Card Promos",
	Fab: "Tournament Legal Promos",
	Jdg: "Judge Promos",
	Lss: "Non-Tournament Legal Promos"
} as const;

export type PrepopulateSet = keyof typeof PrepopulateSetLabels;

export const PrepopulateSetOptions = createOptionsFrom(PrepopulateSetLabels);

export const doesPrepopulateSetHaveColdFoils = (set: PrepopulateSet) => {
	return set !== "WtrUnlimitedEdition"
		&& set !== "ArcUnlimitedEdition"
		&& set !== "CruUnlimitedEdition"
		&& set !== "MonUnlimitedEdition"
		&& set !== "EleUnlimitedEdition";
};

export const doesPrepopulateSetHaveSuperRares = (set: PrepopulateSet) => {
	return set === "Wtr1stEdition"
		|| set === "WtrUnlimitedEdition"
		|| set === "Arc1stEdition"
		|| set === "ArcUnlimitedEdition"
		|| set === "Sup";
};

export const doesPrepopulateSetHaveMarvels = (set: PrepopulateSet) => {
	return set !== "Wtr1stEdition"
		&& set !== "WtrUnlimitedEdition"
		&& set !== "Arc1stEdition"
		&& set !== "ArcUnlimitedEdition"
		&& set !== "Cru1stEdition"
		&& set !== "CruUnlimitedEdition"
		&& set !== "Mon1stEdition"
		&& set !== "MonUnlimitedEdition"
		&& set !== "Ele1stEdition"
		&& set !== "EleUnlimitedEdition"
		&& set !== "Evr1stEdition"
		&& set !== "Fab"
		&& set !== "Her"
		&& set !== "Jdg"
		&& set !== "Lss"
		&& set !== "Lgs";
};

export const isPromoSet = (set: PrepopulateSet) => {
	return set === "Lss"
		|| set === "Lgs"
		|| set === "Fab"
		|| set === "Her"
		|| set === "Jdg";
};

export const doesPrepopulateSetHaveCommons = (set: PrepopulateSet) => {
	return set !== "Anq";
};

export const doesPrepopulateSetHaveFableds = (set: PrepopulateSet) => {
	return set !== "Pen"
		&& set !== "Mpg"
		&& set !== "Mpw";
};
